import React, {useState, useEffect} from 'react';

import ProductList from 'views/product/ProductList';
import AdAPI from 'service/api/AdAPI';

import SetoCanvasPage from 'pages/SetoCanvasPage';
import HeaderBanner from 'views/HeaderBanner';

import 'css/ad.css';


const NepalThemeMerch = (props) => {
    const [products, setProducts] = useState(null);

    useEffect(() => {
        AdAPI.getNepalThemeMerch((products) => {
            setProducts(products);
        });
    }, []);
    return <SetoCanvasPage id="themeMerchPage" title="Nepal T-Shirts, Sweatshirts, Frame and other Nepal Theme Merch available only on setocanvas.com | Seto Canvas"
            metaDescription="Purchase Nepal Theme T-Shirts, Sweatshirts, Frame and more Nepal Theme Merch on setocanvas.com">
            
            <HeaderBanner bannerImages={[{"img": "/images/banners/nepal-merch/nepal_theme_banner.jpg?v=1.1",
                                        "mobileImg": "/images/banners/nepal-merch/nepal_theme_mobile_banner.jpg?v=1.1",
                                        "title": "Nepal Theme T-Shirts, Sweatshirts, Frame and more Nepal Merchandise"},
												]} autoplay={false} />

            <ProductList products={products} viewProductTags={true} flattenProductImages={true}
					productViewMode="productOnly" emptyMsg="No T-Shirts or Sweatshirts Found." />
                    
    </SetoCanvasPage>
};


export default NepalThemeMerch;




// WEBPACK FOOTER //
// ./src/pages/campaigns/NepalThemeMerch.js